import React, { useEffect, useState } from 'react';
import { object as YupObject, string as YupString } from 'yup';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { TabletButton } from '@campfire/tablet-button';
import { Field } from '@campfire/field';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { useSupportContext } from '../SupportContext';
import { IconPickerSelect } from '../../../../common/icons/IconPickerSelect';
import { ColourPickerSelect } from '../../../../common/icons/ColourPickerSelect';

const validationSchema = YupObject().shape({
  categoryTitle: YupString().required('Please provide a name for the category'),
});

interface Props {
  open: boolean;
  close: () => void;
  handleNewCategoryId?: (categoryId: string) => void;
}

const CreateCategoryDialog = (props: Props) => {
  const { open, close, handleNewCategoryId } = props;
  const { isMobile } = useCampfireTheme();
  const { runSaveCategory, saveCategoryIsFulfilled } = useSupportContext();
  const [selectedIcon, setSelectedIcon] = useState<string>('');
  const [selectedColour, setSelectedColour] = useState<string>('');

  useEffect(() => {
    if (saveCategoryIsFulfilled) close();
  }, [saveCategoryIsFulfilled]);

  return (
    <Dialog open={open} fullWidth maxWidth='sm'>
      <Formik
        initialValues={{ categoryTitle: '' }}
        validationSchema={validationSchema}
        onSubmit={async (vals) => {
          const catId = await runSaveCategory({
            title: vals.categoryTitle,
            icon: selectedIcon || undefined,
            colour: selectedColour || undefined,
          });
          if (handleNewCategoryId && catId) handleNewCategoryId(catId);
        }}
      >
        <Form>
          <DialogTitle style={{ paddingRight: isMobile ? 0 : 128 }}>{'Create a new Category'}</DialogTitle>
          <DialogContent>
            <Field
              data-track='resources-create-category-dialog-category-name-input'
              name='categoryTitle'
              label='Category Name'
              variant='outlined'
              helper
              fullWidth
            />

            <Box mt={2} display='flex' alignItems='flex-start' style={{ gap: 16 }}>
              <IconPickerSelect value={selectedIcon} onChange={setSelectedIcon} id='create-category-icon' />
              <ColourPickerSelect value={selectedColour} onChange={setSelectedColour} id='create-category-colour' />
            </Box>
          </DialogContent>
          <DialogActions>
            <TabletButton data-track='resources-create-category-dialog-cancel' onClick={close}>
              {'Cancel'}
            </TabletButton>
            <TabletButton
              data-track='resources-create-category-dialog-submit-button'
              type='submit'
              variant='contained'
              color='primary'
            >
              {'Create Category'}
            </TabletButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export { CreateCategoryDialog };
